export const NEW_MESSAGE_BUTTON_WIDTH = 123;

export const NEW_MESSAGE_BUTTON_WIDTH_NEXT = 147;

export const NEW_MESSAGE_BUTTON_WIDTH_NEXT_WITH_DENSITY = 168;

export const NEW_MESSAGE_BUTTON_WIDTH_WITH_DENSITY = 140;
